import type { CaloriesCalculatorUserData } from "../types/calories-calculator.type";

const ACTIVITY_MULTIPLIERS = {
  low: 1.2,
  moderate: 1.55,
  high: 1.725,
} as const;

const GOAL_ADJUSTMENTS = {
  "eat-healthier": 0,
  maintain: 0,
  "lose-weight": -500,
  "build-muscle": 300,
} as const;

export const calculateDailyCalories = ({
  activityLevel,
  age,
  gender,
  goal,
  height,
  weight,
}: CaloriesCalculatorUserData): number => {
  const bmr =
    gender === "male"
      ? 10 * weight + 6.25 * height - 5 * age + 5
      : 10 * weight + 6.25 * height - 5 * age - 161;

  const tdee = bmr * ACTIVITY_MULTIPLIERS[activityLevel];

  return Math.round(tdee + GOAL_ADJUSTMENTS[goal]);
};
